import { render, staticRenderFns } from "./PcRowComponent.vue?vue&type=template&id=135175ea&"
import script from "./PcRowComponent.vue?vue&type=script&lang=js&"
export * from "./PcRowComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports